<template>
  <div class="til">
    <div class="containe">
      <section style="margin-bottom: 15px">
        <b-field grouped group-multiline>
          <div class="control">
            <button class="button" @click="openCheckSocioModal">Cadastrar Sócio</button>
          </div>
        </b-field>
      </section>

      <section>
        <b-tabs type="is-toggle" expanded>
          <b-tab-item label="Sócios Ativos">
            <b-table
              :data="this.$store.getters['associacao/getAssociacao'] ? this.$store.getters['associacao/getAssociacao'].socios.ativos : []"
              :mobile-cards="true"
              :paginated="true"
              per-page="20"
              current-page.sync="1"
              :pagination-simple="false"
              default-sort-direction="asc"
              default-sort="nome">
            >
              <template slot-scope="props">
                <b-table-column
                  field="id"
                  label="ID"
                  width="40"
                  numeric
                  centered
                >{{ props.index+1 }}</b-table-column>

                <b-table-column
                  field="nome"
                  label="Nome"
                  width="300"
                  centered
                  sortable
                >{{ props.row.nome }}</b-table-column>

                <b-table-column field="last_name" label="Pgto Mensal" centered sortable>
                  <span v-if="verifyStatusPgto(props.row)" class="tag is-success">Em Dias</span>
                  <span v-else class="tag is-danger">Em Débito</span>
                </b-table-column>

                <b-table-column field="last_name" label="Frequência" centered>
                  <span
                    class="tag is-success"
                  >{{ props.row.associacoes[`${idAssociacao}`].frequencia.faltas }} Faltas</span>
                </b-table-column>

                <b-table-column
                  field="data_ingresso"
                  label="Data de Ingresso"
                  centered
                >{{ new Date(props.row.associacoes[`${idAssociacao}`].data_ingresso).toLocaleDateString() }}</b-table-column>

                <b-table-column label="Gerenciar" width="100">
                  <div class="control">
                    <center>
                      <a class="cop-bt cop-bt-success" @click="openViewSocioModal(props.row)">
                        <i class="fas fa-user-edit"></i>
                      </a>
                      <a class="cop-bt cop-bt-danger" @click="openArchiveSocioModal(props.row)">
                        <i class="fas fa-archive"></i>
                      </a>
                    </center>
                  </div>
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                    </p>
                    <p>Não há dados para exibir.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </b-tab-item>

          <b-tab-item label="Sócios Arquivados">
            <b-table
              :data="this.$store.getters['associacao/getAssociacao'] ? this.$store.getters['associacao/getAssociacao'].socios.arquivados : []"
              :mobile-cards="true"
              :paginated="true"
              per-page="20"
              current-page.sync="1"
              :pagination-simple="false"
            >
              <template slot-scope="props">
                <b-table-column
                  field="id"
                  label="ID"
                  width="40"
                  numeric
                  centered
                >{{ props.index+1 }}</b-table-column>

                <b-table-column
                  field="first_name"
                  label="Nome"
                  width="300"
                  centered
                >{{ props.row.nome }}</b-table-column>

                <b-table-column field="last_name" label="CPF" centered>
                  <span>{{props.row.cpf}}</span>
                </b-table-column>

                <b-table-column field="telefone_celular" label="Contato" centered>
                  <span>{{ props.row.telefone_celular }}</span>
                </b-table-column>

                <b-table-column
                  field="date"
                  label="Arquivamento"
                  centered
                >{{ new Date(props.row.date).toLocaleDateString() }}</b-table-column>

                <b-table-column label="Desarquivar" width="100">
                  <div class="control">
                    <center>
                      <a class="cop-bt cop-bt-success" @click="confirm(props.row)">
                        <i class="fas fa-archive"></i>
                      </a>
                    </center>
                  </div>
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                    </p>
                    <p>Não há dados para exibir.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </b-tab-item>
        </b-tabs>
      </section>
    </div>
  </div>
</template>

<script>
import mensalidade_meses from "@/assets/files/mensalidade_meses.json";

import CheckSocioModal from "./components/CheckSocioModal";
import ArchiveSocioModal from "./components/ArchiveSocioModal";
import ViewSocioModal from "./components/ViewSocioModal";

export default {
  data() {
    return {
      idAssociacao: this.$cookies.get("IDASSOCIACAO"),
    };
  },
  methods: {
    confirm(socio) {
      this.$dialog.confirm({
        title: 'Deseja desarquivar o sócio?',
        message: `Nome: ${socio.nome}`,
        onConfirm: () => this.unarchiveSocio(socio._id)
      });
    },

    async unarchiveSocio(socioId) {
      const loadingComponent = this.$loading.open({
        container: null
      });

      await this.$store.dispatch(
        "associacao/unarchivePartnerInFirestore", socioId );
      loadingComponent.close();

      if (this.$store.getters["associacao/getIsSuccess"]) {
        this.$alert("Aviso!", "Sócio Desarquivado!", "success");
      } else {
        this.$alert("Aviso!", "Erro ao desarquivar Sócio!", "danger");
      }
    },

    verifyStatusPgto(socio) {
      let associado = socio.associacoes[`${this.idAssociacao}`];
      let meses = Object.keys(mensalidade_meses);
      let anos = this.$store.getters["associacao/getAssociacao"].anos_plataforma;
      let anoAtual = new Date().getFullYear();
      let mesAtual = new Date().getMonth();
      let diaAtual = new Date().getDay();
      let ingresso = associado.data_ingresso.split("-"); //[ano, mes] ingresso do sócio na entidade
      ingresso[1]--; //Adequa o mês ao padrão 0 - 11 do Date()

      let result = true;

      anos.forEach(ano => {
        if (anoAtual >= ano && ano >= ingresso[0]) {

          if (!associado.mensalidade[`${ano}`]) {
            result = false;
            return;
          }

          let itrMes = ano == anoAtual ? mesAtual+1 : 12;
          let i = ano == ingresso[0] ? ingresso[1]+1 : 0;

          for (; i < itrMes; i++) {

            if (!(anoAtual == ano && i == mesAtual && diaAtual <= 28)) {
              if (!associado.mensalidade[`${ano}`][`${meses[i]}`]){
                result = false;
                return;
              }
            }
          }
        }
      });
      return result; //Está em dias
    },

    openCheckSocioModal() {
      this.$modal.open({
        parent: this,
        component: CheckSocioModal,
        hasModalCard: true
      });
    },

    openArchiveSocioModal(socio) {
      this.$modal.open({
        parent: this,
        component: ArchiveSocioModal,
        hasModalCard: true,
        props: {
          socio: socio
        }
      });
    },

    openViewSocioModal(socio) {
      this.$modal.open({
        parent: this,
        component: ViewSocioModal,
        hasModalCard: true,
        props: {
          socio: JSON.parse(JSON.stringify(socio))
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("associacao/getAssociacaoInFirestore");
  }
};
</script>

<style scoped>
.tab-content {
  padding: 0px !important;
}
.cop-bt {
  margin: 0 5px;
}
.cop-bt-success {
  color: rgb(81, 139, 247);
}
.cop-bt-success:hover {
  color: rgb(17, 67, 158);
  font-size: 1.2rem;
}
.cop-bt-danger {
  color: #ce7676;
}
.cop-bt-danger:hover {
  color: red;
  font-size: 1.2rem;
}
</style>

